// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Documents-DocumentLinks-module__icon";
export { _1 as "icon" }
